/** REASONS SERVICES */

// CREATE A REASON - returns true if create is successful, or throws error.
export async function addNewReason(uId, token, today, reason, order) {
  // build the data 
  const newReason = {
    reason,
    order,
    dateCreated: today,
    dateUpdated: today,
  };
  // REST API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/reasons.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(newReason)
  });
  const responseData = await response.json();
  // err handling
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add a new Reason');
  } else {
    return responseData;
  }
}


// READ ALL REASONS - returns an array of reasons, or empty array.
export async function getAllReasonsFromDbase(uId, token) {
  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/reasons.json?auth=${token}`);
  // error handling
  if(!response.ok) {
    throw new Error(response.message || 'Failed to get all Reasons');
  }
  // manipulate & return data
  const responseData = await response.json();
  let reasons = [];
  if (responseData) {
    for (const key in responseData) {
      const r = responseData[key];
      const reasonObj = {
        id: key,
        reason: r.reason,
        order: r.order ? r.order : r.dateCreated,
        dateCreated: r.dateCreated,
        dateUpdated: r.dateUpdated,
      };
      reasons.push(reasonObj);
    }
    reasons.sort((a, b) => parseInt(a.order) - parseInt(b.order));
  }
  return reasons;
}


// READ ONE REASON - returns one reason object, or false.
export async function getOneReasonFromDbase(uId, token, rId) {
  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/reasons/${rId}.json?auth=${token}`);
  // error handling
  if(!response.ok) {
    throw new Error(response.message || 'Failed to get one Reason');
  }
  // manipulate & return data
  const r = await response.json();

  if (r) {
    return {
      reason: r.reason,
      order: r.order ? r.order : r.dateCreated,
      dateCreated: r.dateCreated,
      dateUpdated: r.dateUpdated,
    };
  } else {
    return false;
  }
}


// UPDATE A REASON - return true update is successful, or throws error
export async function updateReason(uId, token, todayActual, rId, reason, order) {
  const updatedReason = {
    reason,
    order,
    dateUpdated: todayActual,
  }
  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/reasons/${rId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedReason)
  });
  // get the response
  const responseData = await response.json();
  if(!response.ok) {
    throw new Error(response.message || 'Failed to update a Reason');
  } else {
    return responseData;
  }
}


// DELETE A REASON - returns true if delete is successful, or error
export async function deleteReason(uId, token, reasonId) {
  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/reasons/${reasonId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  // response
  const responseData = await response.json();
  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a Reason');
  } else {
    return responseData;
  }
}


